import { config } from '@abyss/web/tools/config';

import { useCustomQuery } from '../useCustomQuery';
import GET_GUEST_ACQUISITION_QUERY from './GuestAcquisition.graphql';

export const useGuestAcquisition = (options) =>
  useCustomQuery(GET_GUEST_ACQUISITION_QUERY, {
    ...options,
    url: config('GRAPHQL_API_URL'),
    accessor: 'getGuestAcquisition',
  });
